import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector
} from "@ngrx/store";
import { IUser } from "src/app/interfaces";
import * as AppState from "./../../state/app.state";
import { UserState } from "./user.reducer";

export interface State extends AppState.State {
  user: UserState;
}

// Selector functions
const selectUserFeatureState = createFeatureSelector<UserState>("user");

export const selectCurrentUser = createSelector(
  selectUserFeatureState,
  (state) => state?.currentUser
);

export const selectIfCurrentUserIs = (predicate: {
  (user: IUser): boolean;
}): MemoizedSelector<State, boolean> =>
  createSelector(selectCurrentUser, (user) => predicate(user));

export const selectIsUserLoaded = createSelector(
  selectUserFeatureState,
  (state) => state?.loaded
);

export const selectError = createSelector(
  selectUserFeatureState,
  (state) => state.error
);
